
<template>
  <div class="mt-4 bg-transparent w-full h-full flex items-self-center justify-between sm:px-6">
  <div class="flex-1 flex justify-between sm:hidden">
    <a href="#" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
      Anterior
    </a>
    <a href="#" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
      Próximo
    </a>
  </div>
  <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
    <div>
      <p class="text-sm text-gray-700 dark:text-gray-500">
        Mostrando
        <span class="font-medium">{{type !== 'no-page' ? data.from : '1'}}</span>
        -
        <span class="font-medium">{{type !== 'no-page' ? data.to : data.total}}</span>
        de
        <span class="font-medium">{{type !== 'no-page' ? data.total : data.total}}</span>
        resultados
      </p>
      <span v-if="!showChangePage" class="w-full flex flex-row items-center gap-x-2 mt-2">
        <p class="text-xs uppercase text-gray-500">Resultados por página:</p>
        <SelectPage label="" placeholder="" :list="pagesSizes" v-model="pageSize" @filter="changePageSize()" desc="descricao"/>
      </span>
    </div>
    <div>
      <nav v-if="type !== 'no-page'" class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
        <button @click="changePage(data.current_page-1)" :disabled="(parseInt(data.current_page)-1) < 1"
        class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
          <span class="sr-only">Previous</span>
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </button>
        <button v-for="page in arrayPages" :key="`l-${page}`" :disabled="page==='...'" :class="parseInt(data.current_page) === parseInt(page) ? 'dark:text-indigo-400' : ''"
        @click="changePage(page)" class="relative inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-700 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
          {{page}}
        </button>
        <button @click="changePage(data.current_page+1)" :disabled="(parseInt(data.current_page)+1) > data.last_page"
        class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800">
          <span class="sr-only">Next</span>
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </button>
      </nav>
    </div>
  </div>
</div>
</template>

<script>
import { computed, onMounted, ref, watch } from 'vue'
import Select from './Select.vue'
import SelectPage from './SelectPage.vue'
export default {
    name: 'Paginator',
    components: {
        SelectPage
    },
    props: ['data', 'type', 'showChangePage'],

    setup (props, { emit }) {
        
        const pageSize = ref(10)

        const arrayPages = ref([])

        const changePage = (page) => {
            emit('changePage', page)
        }

        const changePageSize = () => {
            emit('changePageSize', pageSize.value)
        }

        const getPages = () => {
            const current = props.data.current_page
            const last = props.data.last_page
            const delta = 2
            const left = current - delta
            const right = current + delta + 1
            const range = []
            const rangeWithDots = []
            let l

            for (let i = 1; i <= last; i++) {
                if (i == 1 || i == last || i >= left && i < right) {
                    range.push(i)
                }
            }

            for (const i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1)
                    } else if (i - l !== 1) {
                        rangeWithDots.push('...')
                    }
                }
                rangeWithDots.push(i)
                l = i
            }

            arrayPages.value = rangeWithDots
        }
        getPages()

        watch(() => props.data, (data, prev) => {
            getPages()
        }, { deep: true })

        const pagesSizes = [
            { id: 10, descricao: 10 },
            { id: 20, descricao: 20 },
            { id: 50, descricao: 50 },
            { id: 75, descricao: 75 },
            { id: 100, descricao: 100 }
        ]
        return {
            arrayPages,
            pagesSizes,
            pageSize,
            changePage,
            changePageSize
        }
    }

}
</script>
<style scoped>

</style>
